
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "19",
    "height": "21"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "fill": "#FFF",
        "fill-rule": "evenodd",
        "d": "M18.163 4.665h-.759l-1.335 14.719c-.033.36-.336.636-.698.634H4.2c-.362.002-.665-.274-.698-.634L2.166 4.665h-.758c-.386 0-.699-.313-.699-.698 0-.385.313-.698.699-.698h4.887v-.698c0-1.156.937-2.093 2.094-2.093h2.793c1.156 0 2.094.937 2.094 2.093v.698h4.887c.386 0 .699.312.699.698 0 .385-.313.698-.699.698zM11.88 2.571c0-.385-.313-.698-.698-.698H8.389c-.385 0-.698.313-.698.698v.698h4.189v-.698zM6.993 4.665H3.572l1.266 13.957h9.895l1.27-13.957h-9.01zm5.585 12.562h-.05l-.003-.001c-.384-.028-.673-.362-.645-.747l.698-9.77c.027-.385.362-.676.748-.648.385.027.676.362.648.747l-.698 9.77c-.026.366-.331.65-.698.649zm-2.793 0c-.385 0-.698-.313-.698-.698V6.758c0-.385.313-.697.698-.697.386 0 .699.312.699.697v9.771c0 .385-.313.698-.699.698zm-2.742 0h-.05c-.367.001-.672-.283-.698-.649l-.699-9.77c-.027-.385.264-.72.649-.747.386-.028.72.263.748.648l.698 9.77v.003c.027.385-.263.718-.648.745z"
      }
    }
  ]
})
    }
  